function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './../spzaComponent';
import { CommunityItemType } from '@shared/Models';
import { Constants } from '../../utils/constants';
import { RichTextDropDown } from '../richTextDropDown';
import { SpzaInstrumentService } from '../../services/telemetry/spza/spzaInstrument';
import { getWindow } from '../../services/window';
import { isEmailValid, focusElement } from '../../utils/appUtils';
import classNames from 'classnames';
import { logger } from '@src/logger';
import checkLarge from '@shared/images/checkLarge.png';
class ReportAbuseModal extends SpzaComponent {
    componentDidMount() {
        focusElement(Constants.SearchBy.Id, Constants.ReportAbuseDialog.dropdownHTMLIdName);
    }
    getDropDownOptions() {
        if (this.textDropDownItems) {
            return this.textDropDownItems;
        }
        this.textDropDownItems = Constants.Avert.ReportAbuseCategories.map((abuseCategory)=>{
            return {
                text: this.context.loc(abuseCategory.locKey),
                value: abuseCategory.dropDownValue
            };
        });
        return this.textDropDownItems;
    }
    onCommentsChange(event) {
        const comment = event.target.value;
        this.setState((prevState)=>{
            return {
                category: prevState.category,
                additionalComments: comment,
                successMode: prevState.successMode,
                reviewContent: prevState.reviewContent,
                email: prevState.email,
                validEmail: prevState.validEmail
            };
        });
    }
    onEmailChange(event) {
        const email = event.target.value;
        this.setState({
            email: email
        });
        if (!email || isEmailValid(this.state.email)) {
            this.setState({
                validEmail: true
            });
        } else {
            this.setState({
                validEmail: false
            });
        }
    }
    setSuccessState() {
        this.setState((prevState)=>{
            return {
                category: prevState.category,
                additionalComments: prevState.additionalComments,
                reviewContent: prevState.reviewContent,
                successMode: true,
                email: prevState.email,
                validEmail: prevState.validEmail
            };
        });
    }
    getReportCategory(selectedValue) {
        const abuseCategory = Constants.Avert.ReportAbuseCategories.filter((category)=>{
            return category.dropDownValue === selectedValue;
        });
        return abuseCategory && abuseCategory[0] ? abuseCategory[0].avertIdentifier : Constants.Avert.ReportAbuseCategories[0].avertIdentifier;
    }
    handleSubmit() {
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.ReportModal,
            appName: this.props.appId,
            details: JSON.stringify({
                category: this.state.category.value,
                comments: this.state.additionalComments,
                reviewId: this.props.reviewId,
                reviewSource: this.props.reviewSource,
                reviewContent: this.state.reviewContent,
                email: this.state.email
            })
        };
        this.instrument.probe('logAndFlushTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            appName: payload.appName
        });
        const { storefrontName, appId, reviewId } = this.props;
        const postItemReport = {
            category: this.getReportCategory(this.state.category.value),
            source: storefrontName,
            offerId: appId,
            itemId: reviewId,
            comments: this.state.additionalComments,
            itemType: CommunityItemType.Review
        };
        this.props.reportReview(postItemReport);
        this.setSuccessState();
    }
    setFocusInsideDialog(e) {
        if (e.shiftKey && e.keyCode === Constants.SystemKey.Tab) {
            const submitButton = document.getElementById('reportAbuseModalSubmitButton');
            window.setTimeout(function() {
                submitButton.focus();
            }, 0);
        }
    }
    getCancelButton() {
        return /*#__PURE__*/ _jsx("div", {
            className: "toolBar",
            children: /*#__PURE__*/ _jsx("button", {
                // eslint-disable-next-line react/forbid-dom-props
                id: "cancelButton",
                "aria-label": "close",
                className: "cancel",
                onClick: this.props.dismissModal.bind(this),
                onKeyDown: (event)=>{
                    this.setFocusInsideDialog(event);
                },
                children: /*#__PURE__*/ _jsx("span", {
                    className: "c-glyph"
                })
            })
        });
    }
    getRatingCategoryDropDown() {
        return /*#__PURE__*/ _jsx(RichTextDropDown, {
            className: "categoryDropDown",
            id: Constants.ReportAbuseDialog.dropdownHTMLIdName,
            options: this.getDropDownOptions(),
            value: this.state.category,
            dropdownLabel: this.context.loc('ReportModal_Category_Label'),
            onChangeHandle: (option)=>this.setState((prevState)=>{
                    return {
                        category: option,
                        additionalComments: prevState.additionalComments,
                        reviewContent: prevState.reviewContent,
                        successMode: prevState.successMode,
                        email: prevState.email,
                        validEmail: prevState.validEmail
                    };
                })
        });
    }
    getReviewTitle() {
        return /*#__PURE__*/ _jsx("div", {
            className: "reviewTitleSection",
            children: /*#__PURE__*/ _jsx("div", {
                className: "itemLabel",
                children: this.context.loc('ReportModal_ReviewTitle_Label') + ': ' + this.props.reviewTitle
            })
        });
    }
    renderImpl() {
        if (this.state.successMode) {
            return /*#__PURE__*/ _jsxs("div", {
                role: "dialog",
                "aria-label": "rating and review dialog is now open",
                className: "reportAbuseModalClass",
                children: [
                    this.getCancelButton(),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "successDialog",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "successHeader",
                                children: this.context.loc('ReportModal_Success_Done_Text')
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "successCheck",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: checkLarge
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "successFooter",
                                children: /*#__PURE__*/ _jsx("button", {
                                    name: "button",
                                    className: "c-button requestButton",
                                    type: "submit",
                                    "data-bi-id": Constants.JsllCTAId.Done,
                                    "data-bi-area": "Report Abuse Dialog",
                                    onClick: this.props.dismissModal.bind(this),
                                    children: this.context.loc('ReportModal_Success_Done_Label')
                                })
                            })
                        ]
                    })
                ]
            });
        }
        const reportModalClassName = classNames({
            reportAbuseModalClass: true,
            invalidReviewMode: this.state.category.value === Constants.Avert.ReportAbuseCategories[3].dropDownValue,
            invalidEmailText: this.state.category.value === Constants.Avert.ReportAbuseCategories[3].dropDownValue && !this.state.validEmail
        });
        return /*#__PURE__*/ _jsxs("div", {
            role: "dialog",
            "aria-label": "report abuse modal is now open",
            className: reportModalClassName,
            children: [
                this.getCancelButton(),
                /*#__PURE__*/ _jsx("div", {
                    className: "title",
                    children: this.context.loc('ReportModal_Title_Text')
                }),
                this.getReviewTitle(),
                /*#__PURE__*/ _jsxs("div", {
                    className: "categorySection",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "itemLabel",
                                children: this.context.loc('ReportModal_Category_Label')
                            })
                        }),
                        this.getRatingCategoryDropDown()
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "commentsSection",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "itemLabel",
                            children: this.context.loc('ReportModal_AdditionalComments_Label')
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "c-textarea",
                            children: /*#__PURE__*/ _jsx("textarea", {
                                // eslint-disable-next-line react/forbid-dom-props
                                id: "additionalComments",
                                "aria-label": this.context.loc('ReportModal_AdditionalComments_Label'),
                                className: "f-no-resize",
                                rows: 3,
                                maxLength: 400,
                                onChange: this.onCommentsChange.bind(this),
                                role: "textbox"
                            })
                        })
                    ]
                }),
                this.state.category.value === Constants.Avert.ReportAbuseCategories[3].dropDownValue ? /*#__PURE__*/ _jsxs("div", {
                    className: "emailSection",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "itemLabel",
                            children: this.context.loc('ReportModal_Email_Label')
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "emailInputContainer",
                            children: /*#__PURE__*/ _jsx("input", {
                                // eslint-disable-next-line react/forbid-dom-props
                                id: "emailSection",
                                "aria-label": this.context.loc('ReportModal_Email_Label'),
                                className: this.state.validEmail ? '' : 'invalidEmailAddress',
                                onChange: this.onEmailChange.bind(this)
                            })
                        }),
                        this.state.validEmail ? null : /*#__PURE__*/ _jsx("span", {
                            className: "invalidEmailText",
                            children: this.context.loc('Feedback_invalidEmail')
                        })
                    ]
                }) : null,
                /*#__PURE__*/ _jsx("div", {
                    className: "submitSection",
                    children: /*#__PURE__*/ _jsx("button", {
                        name: "submitButton",
                        // eslint-disable-next-line react/forbid-dom-props
                        id: "reportAbuseModalSubmitButton",
                        className: "c-button",
                        disabled: this.state.category.value === Constants.Avert.ReportAbuseCategories[3].dropDownValue && !this.state.additionalComments || this.state.category.value === Constants.Avert.ReportAbuseCategories[3].dropDownValue && !this.state.validEmail,
                        role: "button",
                        type: "submit",
                        "aria-label": this.context.loc('NPS_SubmitButton'),
                        onClick: ()=>this.handleSubmit(),
                        children: this.context.loc('ReportModal_SubmitButton_Label')
                    })
                })
            ]
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "textDropDownItems", void 0), _define_property(this, "instrument", void 0);
        this.context = context;
        this.instrument = SpzaInstrumentService.getProvider();
        this.state = {
            category: this.getDropDownOptions()[0],
            successMode: false,
            reviewContent: '',
            additionalComments: '',
            validEmail: true,
            email: ''
        };
    }
}
export { ReportAbuseModal as default };
ReportAbuseModal.contextTypes = {
    loc: PropTypes.func
};
